import React, { useCallback } from "react";
import { FormSection, Field, getFormValues, change, focus } from "redux-form";
import { useDispatch, useSelector } from "react-redux";

import  {
	Card
} from "rhombus-react";

import { CREATIVE_ASSET_TYPES, SOCIAL_AD_TYPES, SOCIAL_FORMATS } from "utils/constants";
import { isDynamic } from "social/DynamicCreativeToggle";
import { assetType } from "social/BuildMethodRadio";
import {
	FACEBOOK_CAROUSEL_MO_FIELDS
} from "social/carousel/FacebookCarouselCardForm";
import { useErrorBanner } from "social/utils";
import { SOCIAL_WIZARD } from "widgets/forms/list";

import FacebookMOMainContent from "social/carousel/FacebookMOMainContent";
import FacebookCardContent from "social/carousel/FacebookCardContent";

export default function FacebookCarouselMO(props){
	const {
		isEditMode,
		libraryId,
		navigationActions,
		isViewOnly,
		showPristineErrors,
		doVersionsExist,
	} = props;
	const adType = SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO;

	const showPristine = showPristineErrors || ["cardCount"]; // Always show at least the card count error

	const errorDisplay = useErrorBanner(adType, showPristine, FACEBOOK_CAROUSEL_MO_FIELDS);

	const dispatch = useDispatch();
	const cards = useSelector(state => getFormValues(SOCIAL_WIZARD)(state)?.[adType]?.cards);

	const onAssetTypeChange = useCallback((eventOrValue, value) => {
		const newValue = value !== undefined ? value : eventOrValue;
		if(newValue === CREATIVE_ASSET_TYPES.AFTER_EFFECTS && Array.isArray(cards)){
			cards.forEach((card, index) => {
				const typePath = `${adType}.cards[${index}].type`;
				dispatch(change(SOCIAL_WIZARD, typePath, SOCIAL_FORMATS.VIDEO, true));
				dispatch(focus(SOCIAL_WIZARD, typePath));
			});
		}
	}, [cards, dispatch, adType]);

	return (
		<FormSection name={adType}>
			<div className="carousel-modal-content">
				{errorDisplay}
				<div className="form-container">
					<div className="fields">
						<Field {...isDynamic} />
						<Field {...assetType} onChange={onAssetTypeChange} />
					</div>
				</div>
				<Card
					className="carousel-main-content"
					header="Main Content"
					isCollapsable
					isVisible
				>
					<FacebookMOMainContent
						adType={adType}
						isEditMode={isEditMode}
						isViewOnly={isViewOnly}
						showPristineErrors={showPristineErrors}
						doVersionsExist={doVersionsExist}
					/>
				</Card>
				<FacebookCardContent
					libraryId={libraryId}
					adType={adType}
					isEditMode={isEditMode}
					isViewOnly={isViewOnly}
					showPristineErrors={showPristineErrors}
					navigationActions={navigationActions}
					doVersionsExist={doVersionsExist}
				/>
			</div>
		</FormSection>
	);
}
